export const PRIZE = 'leaderBoardColumnType/PRIZE';
export const STATUS = 'leaderBoardColumnType/STATUS';
